import React, { Fragment } from 'react';
import { pick, pipe } from 'ramda';
import { useLocation } from 'react-router-dom';
import { Link } from 'js/components/common/Link';
import { useAppSelector } from 'js/store/hooks';
import { BackboneReplacer } from 'js/backbone/components/BackboneReplacer';
import { useOpenChat, useOpenInbox } from 'js/components/system/CommunicationWidgets/hooks';

import * as hooks from 'js/components/main/NavigationBar/hooks';
import * as helpers from 'js/components/main/NavigationBar/helpers';

import style from 'js/components/main/NavigationBar/NavigationBar.scss';

export const NavigationBar = ({ currentPageURL }) => {
    const customCssClass = 'pokerLink';
    const location = useLocation();
    const { rootPage, menuItems, chatWidget, inboxWidget } = useAppSelector(pick(['rootPage', 'menuItems', 'chatWidget', 'inboxWidget']));
    const isActive = item => item.url === currentPageURL || currentPageURL === '/' && item.url === rootPage;
    const filterByRoleAvailability = hooks.useFilterByRoleAvailability();

    const onOpenInbox = useOpenInbox();
    const onOpenChat = useOpenChat();

    const currentMenuItems = pipe(
        helpers.getMenuSiblingsByUrl(currentPageURL || rootPage),
        filterByRoleAvailability,
        helpers.markMenuItemAsOpener(chatWidget, inboxWidget),
        helpers.filterByUrlAvailability(location.search)
    )(menuItems);

    currentMenuItems.forEach(el => {
        if (el.cssClasses === customCssClass && el.name.split(' ').length > 1) {
            el.customClass = true;
        }
    });

    return (
        <div className={`${currentMenuItems[0]?.cssClasses === customCssClass ? style.containerPoker : style.container} cms-navigation-bar`}>
            <ul className={style.list}>
                {currentMenuItems.map(item => (
                    <Fragment key={item.url}>
                        {item.inboxOpener && (
                            <li
                                className={`${style.listItem} ${item.cssClasses ? `${item.cssClasses} ` : ''}`}
                                onClick={onOpenInbox}>
                                <span className={`${style.listItemPoint} ${style.listItemPointReplacer}`}>
                                    <div className={style.replacerContainer}>
                                        <span className={`micon-${item.menuIcon ? item.menuIcon : ''}`} />
                                        <span className={`${style.itemName} ${style.replacerItem}`}>{item.name}</span>
                                        <BackboneReplacer dynamicName={'UNREAD_MESSAGES_COUNT'} viewName={'unreadmessagescount'} />
                                    </div>
                                </span>
                            </li>
                        )}
                        {item.chatOpener && (
                            <li
                            className={`${style.listItem} ${item.cssClasses ? `${item.cssClasses} ` : ''}`}
                                onClick={onOpenChat}>
                                <span className={`${style.listItemPoint} ${style.listItemPointReplacer}`}>
                                    <div className={style.replacerContainer}>
                                        <span className={`micon-${item.menuIcon ? item.menuIcon : ''}`} />
                                        <span className={`${style.itemName} ${style.replacerItem}`}>{item.name}</span>
                                        <BackboneReplacer dynamicName={'CHAT_UNREAD'} viewName={'chatunread'} />
                                    </div>
                                </span>
                            </li>
                        )}
                        {!item.inboxOpener && !item.chatOpener && (
                            <li
                                className={
                                    `${item.cssClasses && item.cssClasses === customCssClass
                                        ? `${style.listItemPoker} ${style.pokerLink} ${isActive(item)
                                            ? `${style.isActivePokerLink} active` : ''}`
                                        : `${style.listItem}`} ${item.cssClasses ? `${item.cssClasses} ` : ''}${isActive(item) ? `${style.isActive} active` : ''}`
                                }
                                data-url={item.url}
                                {...(item.dyUnit ? { 'data-dyUnit': `${item.dyUnit}` } : {})}
                            >
                                <Link
                                    href={item.url}
                                    className={`${style.link} ${item.cssClasses === customCssClass ? `${style.listItemPointPoker}` : `${style.listItemPoint}`}`}
                                >
                                    <span className={`micon-${item.menuIcon ? item.menuIcon : ''}`} />
                                    {item.cssClasses === 'bonus-counter' && <BackboneReplacer dynamicName={'BONUS_COPIED'} viewName={'bonuscopied'} />}
                                    {item.cssClasses === customCssClass && (
                                        <div className={item.customClass === true
                                            ? style.itemNamePoker
                                            : style.itemName}
                                        >
                                            {item.name}
                                        </div>
                                    )}
                                    {item.cssClasses !== customCssClass && (
                                        <span className={style.itemName}>{item.name}</span>
                                    )}
                                </Link>
                            </li>
                        )}
                    </Fragment>
                ))}
            </ul>
        </div>
    );
};
